var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.cities,"label":_vm.label,"rules":_vm.rules,"disabled":_vm.disabled,"item-text":"name","clearable":""},model:{value:(_vm.childData),callback:function ($$v) {_vm.childData=$$v},expression:"childData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }